import { apiClient } from '_app'
import { CancelToken } from 'axios'
import {
  ApiResponse,
  MoveVehicleDto,
  Needs7501DocumentMichiganEmailExporterDto,
  NeedsCANOwnershipMichiganEmailExporterDto,
  NeedsClusterRemovedDetailsDto,
  NeedsClusterRemovedPulledClusterPhotoDto,
  NeedsToBeMovedToStagingDetailsDto,
  NeedsToBeMovedToStagingWarrantyCertPhotoDto,
  VehicleBondCommunicationDto,
  VehicleBondInformationDto,
  VehicleBondNoteDto,
  VehicleCANOwnershipDto,
  VehicleCheckInCheckInClusterPhotoDto,
  VehicleCheckInCurrentDto,
  VehicleCheckInDetailsDto,
  VehicleClusterInformationDto,
  VehicleClusterTimelineDto,
  VehicleConformityDetailsDto,
  VehicleConformitySubmissionIssuesDto,
  VehicleDamageDetailsDto,
  VehicleDamageDto,
  VehicleDamageNoteDto,
  VehicleDamagePhotosDto,
  VehicleDocumentDto,
  VehicleDto,
  VehicleExporterInformationDto,
  VehicleExporterNoteDto,
  VehicleExporterPhotosDto,
  VehicleImporterNoteDto,
  VehicleIncorrectMileageResolutionDto,
  VehicleInvoicingDto,
  VehicleLockStatusDto,
  VehicleMichiganTitleApplicationPacketDto,
  VehicleNeedsClusterConversionInHouseDetailsDto,
  VehicleNeedsInHouseAdditionalProgrammingDetailsDto,
  VehicleNeedsThirdPartyAdditionalProgrammingDetailsDto,
  VehicleOdometerAfterModificationPhotoDto,
  VehicleParkingSpaceDto,
  VehicleRecallDto,
  VehicleRecallNoteDto,
  VehicleReferenceDto,
  VehicleSendBackToCanadaDto,
  VehicleSpecialBondRequestDto,
  VehicleWaitingOnThirdPartyAdditionalProgrammingDetailsDto,
  VehicleWaitingOnThirdPartyConversionCompanyDetailsDto
} from 'dtos'
import { VehicleTransactionDto } from 'dtos/invoicing'
import { NeedsClusterReinstalledClusterWithOdometerPhotoDto } from 'dtos/needsClusterReinstalledClusterWithOdometerPhotoDto'
import { NeedsClusterReinstalledComboPhotoDto } from 'dtos/needsClusterReinstalledComboPhotoDto'
import { NeedsClusterReinstalledDetailsDto } from 'dtos/needsClusterReinstalledDetailsDto'
import { NeedsClusterReinstalledImporterDoorLabelPhotoDto } from 'dtos/needsClusterReinstalledImporterDoorLabelPhotoDto'
import { VehicleActivityLogDto } from 'dtos/vehicleActivityLogDto'
import { VehicleCheckInAirbagTellTalePhotoDto } from 'dtos/vehicleCheckInAirbagTelltalePhotoDto'
import { VehicleCheckInBackupCamPhotoDto } from 'dtos/vehicleCheckInBackupCamPhotoDto'
import { VehicleCheckInClusterWithOdometerPhotoDto } from 'dtos/vehicleCheckInClusterWithOdometerPhotoDto'
import { VehicleCheckInComboPhotoDto } from 'dtos/vehicleCheckInComboPhotoDto'
import { VehicleCheckInDriverAirbagPhotoDto } from 'dtos/vehicleCheckInDriverAirbagPhotoDto'
import { VehicleCheckInFrontCornerPhotoDto } from 'dtos/vehicleCheckInFrontCornerPhotoDto'
import { VehicleCheckInFrontHeadOnPhotoDto } from 'dtos/vehicleCheckInFrontHeadOnPhotoDto'
import { VehicleCheckInImporterDoorLabelPhotoDto } from 'dtos/vehicleCheckInImporterDoorLabelPhotoDto'
import { VehicleCheckInManufacturerLabelDatesDto } from 'dtos/vehicleCheckInManufacturerLabelDatesDto'
import { VehicleCheckInManufacturersLabelPhotoDto } from 'dtos/vehicleCheckInManufacturersLabelPhotoDto'
import { VehicleCheckInPassengerAirbagPhotoDto } from 'dtos/vehicleCheckInPassengerAirbagPhotoDto'
import { VehicleCheckInRearCornerPhotoDto } from 'dtos/vehicleCheckInRearCornerPhotoDto'
import { VehicleCheckInRearHeadOnPhotoDto } from 'dtos/vehicleCheckInRearHeadOnPhotoDto'
import { VehicleCheckInRoofPhotoDto } from 'dtos/vehicleCheckInRoofPhotoDto'
import { VehicleCheckInTirePressureLabelDatesDto } from 'dtos/vehicleCheckInTirePressureLabelDatesDto'
import { VehicleCheckInTirePressureLabelPhotoDto } from 'dtos/vehicleCheckInTirePressureLabelPhotoDto'
import { VehicleCheckInVINOnDashboardPhotoDto } from 'dtos/vehicleCheckInVINOnDashboardPhotoDto'
import { VehicleTitleDto } from 'dtos/vehicles/titles'
import {
  ExportersParameters,
  VehicleActivityLogParameters,
  VehicleBondCommunicationParameters,
  VehicleBondNoteParameters,
  VehicleDocumentsParameters,
  VehicleExporterNoteParameters,
  VehicleImporterNoteParameters,
  VehicleRecallNoteParameters,
  VehicleTransactionParameters
} from 'parameters'
import { VehicleDamageNoteParameters } from 'parameters/vehicleDamageNoteParameters'
import { VehicleDamageParameters } from 'parameters/vehicleDamageParameters'
import { VehicleRecallParameters } from 'parameters/vehicleRecallParameters'
import {
  ToDoListCanceledParameters,
  ToDoListConformitySentToDOTHoldParameters,
  ToDoListMichiganTitlesParameters,
  ToDoListMissouriTitlesParameters,
  ToDoListNeedsBOLInVehicleParameters,
  ToDoListNeedsBWIApprovalParameters,
  ToDoListNeedsBrokerDocumentsParameters,
  ToDoListNeedsCaRoUploadedParameters,
  ToDoListNeedsCheckInParameters,
  ToDoListNeedsClusterConversionShipperParameters,
  ToDoListNeedsClusterDeliveredToThirdPartyConversionCompanyParameters,
  ToDoListNeedsClusterProgrammingParameters,
  ToDoListNeedsClusterReinstalledParameters,
  ToDoListNeedsClusterRemovedParameters,
  ToDoListNeedsConformityPhotosParameters,
  ToDoListNeedsConformitySentToDOTParameters,
  ToDoListNeedsDamageRepairedParameters,
  ToDoListNeedsIncorrectMileageResolutionParameters,
  ToDoListNeedsInvoiceParameters,
  ToDoListNeedsManufacturerLabelExporterParameters,
  ToDoListNeedsManufacturerLabelParameters,
  ToDoListNeedsOEMSiteCheckedForRecallsParameters,
  ToDoListNeedsOutboundPhotosParameters,
  ToDoListNeedsPhotoParameters,
  ToDoListNeedsRecallDocsParameters,
  ToDoListNeedsRecallWorkParameters,
  ToDoListNeedsShipperConversionParameters,
  ToDoListNeedsShipperProgrammingParameters,
  ToDoListNeedsSignedForeignShipperParameters,
  ToDoListNeedsSpecialBondParameters,
  ToDoListNeedsTMPSLabelExporterParameters,
  ToDoListNeedsTMPSLabelParameters,
  ToDoListNeedsTirePressureLabelParameters,
  ToDoListNeedsToBeAddedToPAPSParameters,
  ToDoListNeedsToBeShippedOutboundParameters,
  ToDoListNeedsTripInfoParameters,
  ToDoListNoCANOwnershipParameters,
  ToDoListOhioTitlesParameters,
  ToDoListOutgoingTitlesParameters,
  ToDoListVehicleOnLotParameters,
  ToDoListWMAAParameters,
  ToDoListWaitingOnConversionParameters,
  ToDoListWaitingOnProgrammmingParameters,
  ToDoListWaitingOnTripParameters
} from 'parameters/vehiclesParameters'
import { URIQuery, base64ToArrayBuffer, objectToFormData } from 'utils'

const baseUrl = (): string => '/api/vehicles'
const guidUrl = (vehicleGuid: string) => `${baseUrl()}/${encodeURIComponent(vehicleGuid)}`

export const getCANOwnership = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<VehicleCANOwnershipDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/can-ownership`).then(res => res.data)

export const getMichiganTitleApplicationPacket = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleMichiganTitleApplicationPacketDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/michigan-title-application-packet`)
    .then(res => res.data)

export const getTitle = (vehicleGuid: string) => apiClient.get<ApiResponse<VehicleTitleDto>>(`${guidUrl(vehicleGuid)}/title`).then(res => res.data)

export const lockVehicles = (values: VehicleDto[]) => apiClient.put('/api/vehicles/lock', values).then(response => response.data)

export const unlockVehicles = (values: VehicleDto[]) => apiClient.put('/api/vehicles/unlock', values).then(response => response.data)

export const getVehicles = (parameters: ExportersParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getVehicleToMove = (search: string) =>
  apiClient.get<ApiResponse<MoveVehicleDto | undefined>>('/api/vehicles/move-vehicle?search=' + encodeURIComponent(search)).then(response => response.data)

export const moveVehicle = (values: MoveVehicleDto) =>
  apiClient.put<ApiResponse<MoveVehicleDto>>('/api/vehicles/move-vehicle', values).then(response => response.data)

export const getVehicleById = (id: string) => apiClient.get<ApiResponse<VehicleDto>>('/api/vehicles/' + encodeURIComponent(id)).then(res => res.data)

export const getVehicleByVIN = (vin: string) =>
  apiClient.get<ApiResponse<VehicleDto | undefined>>('/api/vehicles/vin/' + encodeURIComponent(vin)).then(res => res.data)

export const getVehicleLockStatus = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<VehicleLockStatusDto>>('/api/vehicles/' + encodeURIComponent(vehicleGuid) + '/lock-status').then(response => response.data)

export const createVehicle = (values: VehicleDto) => apiClient.post<ApiResponse<VehicleDto>>('/api/vehicles', values).then(({ data }) => data)

export const updateVehicle = (values: VehicleDto) => apiClient.put<ApiResponse<VehicleDto>>('/api/vehicles', values).then(({ data }) => data)

export const cancelImport = (vehicleGuid: string) =>
  apiClient.put<ApiResponse<VehicleDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/cancel-import`).then(response => response.data)

export const getExportersDashboard = (parameters: ExportersParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/exporters-dashboard' + URIQuery({ ...parameters })).then(res => res.data)

export const getExportersDashboardExport = (parameters: ExportersParameters) =>
  apiClient.get('/api/vehicles/exporters-dashboard/export' + URIQuery({ ...parameters })).then(res => {
    const blob = new Blob([res.data], { type: (res.headers['content-type'] ?? undefined) as string | undefined })
    const headers = res.headers['content-disposition'].split(';') as string[]

    const filename = headers
      .map(header => header.trim())
      .filter((header: string) => header.startsWith('filename='))[0]
      .replace('filename=', '')

    const a = document.createElement('a')
    const blobUrl = window.URL.createObjectURL(blob)
    a.href = blobUrl
    a.setAttribute('download', filename)
    document.body.appendChild(a)
    a.click()
  })

export const getVehicleCheckInPhotoBase64 = (vehicleGuid: string, documentGuid: string) =>
  apiClient
    .get<string>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/${encodeURIComponent(documentGuid)}`)
    .then(response => response.data)

export const getNeedsClusterRemovedPhotoBase64 = (vehicleGuid: string, documentGuid: string) =>
  apiClient
    .get<string>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-removed/${encodeURIComponent(documentGuid)}`)
    .then(response => response.data)

export const getNeedsClusterReinstalledPhotoBase64 = (vehicleGuid: string, documentGuid: string) =>
  apiClient
    .get<string>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/${encodeURIComponent(documentGuid)}`)
    .then(response => response.data)

export const getSearchedVehicles = (search: string) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/search' + URIQuery({ q: search })).then(res => res.data)

export const decodeVinValues = (vin: string, modelYear?: string) =>
  apiClient.get<ApiResponse<VehicleDto | undefined>>('/api/vehicles/decode-vin/' + vin + URIQuery({ modelYear })).then(res => res.data)

export const getVehicleBondCommunications = (vehicleGuid: string, parameters: VehicleBondCommunicationParameters) =>
  apiClient
    .get<ApiResponse<VehicleBondCommunicationDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/bond-communications` + URIQuery({ ...parameters }))
    .then(response => response.data)

// TODO: Remove
// Maxwell Sommer 09/10/2024
export const getVehicleBondNotes = (parameters: VehicleBondNoteParameters, vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleBondNoteDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/bond-notes` + URIQuery({ ...parameters, vehicleId }))
    .then(({ data }) => data)

export const getVehicleExporterNotes = (vehicleGuid: string, parameters: VehicleExporterNoteParameters) =>
  apiClient
    .get<ApiResponse<VehicleExporterNoteDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/exporter-notes` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const createExporterNote = (values: VehicleExporterNoteDto, vehicleId: string) =>
  apiClient.post<ApiResponse<VehicleExporterNoteDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/exporter-notes`, values).then(res => res.data)

export const getExporterInformation = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleExporterInformationDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/exporter-information`)
    .then(response => response.data)

export const updateExporterInformation = (vehicleGuid: string, values: VehicleExporterInformationDto) =>
  apiClient
    .put<ApiResponse<VehicleExporterInformationDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/exporter-information`, values)
    .then(response => response.data)

export const getBondInformation = (vehicleId: string) =>
  apiClient.get<ApiResponse<VehicleBondInformationDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/bond-information`).then(response => response.data)

export const updateBondInformation = (vehicleGuid: string, values: VehicleBondInformationDto) =>
  apiClient
    .put<ApiResponse<VehicleBondInformationDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/bond-information`, values)
    .then(response => response.data)

export const getSpecialBondRequest = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleSpecialBondRequestDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/special-bond-request`)
    .then(response => response.data)

export const updateSpecialBondRequest = (vehicleGuid: string, values: VehicleSpecialBondRequestDto) =>
  apiClient
    .put<ApiResponse<VehicleSpecialBondRequestDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/special-bond-request`, values)
    .then(response => response.data)

export const getVehicleConformityDetails = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<VehicleConformityDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/conformity-details`).then(response => response.data)

export const updateVehicleConformityDetails = (vehicleGuid: string, values: VehicleConformityDetailsDto) =>
  apiClient
    .put<ApiResponse<VehicleConformityDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/conformity-details`, values)
    .then(response => response.data)

export const downloadConformityZip = async (vehicleGuid: string, conformityZipDownloadUrl: string) => {
  const response = await apiClient.get(`/api/vehicles/${vehicleGuid}/conformity-details/zip-download`, {
    responseType: 'blob'
  })

  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }))
  const a = document.createElement('a')
  a.href = url
  a.download = 'conformity-details.zip'
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(url)
}

export const getVehicleConformitySubmissionIssues = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleConformitySubmissionIssuesDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/conformity-submission-issues`)
    .then(response => response.data)

// export const updateVehicleDOTRejection = (vehicleGuid: string, values: VehicleDOTRejectionDto) =>
//   apiClient
//     .put<ApiResponse<VehicleDOTRejectionDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/dot-rejection`, values)
//     .then(response => response.data)

export const updateVehicleConformitySubmissionIssues = (vehicleGuid: string, values: VehicleConformitySubmissionIssuesDto) => {
  const formData = new FormData()
  formData.append('IssueDate', values.issueDate?.toString() ?? '')
  formData.append('IssueReason', values.issueReason ?? '')
  formData.append('IssueNote', values.issueNote ?? '')
  formData.append('NeedsToBeSentBackToCanada', values.needsToBeSentBackToCanada ?? '')

  if (values.issueDocumentationFile) {
    formData.append('IssueDocumentationFile', values.issueDocumentationFile)
  }

  return apiClient
    .put<ApiResponse<VehicleConformitySubmissionIssuesDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/conformity-submission-issues`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => response.data)
}

export const getIssueDocumentationFile = (vehicleGuid: string, fileName: string) =>
  apiClient.get(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/conformity-submission-issues/${encodeURIComponent(fileName)}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const extension = fileName.split('.').pop()?.toLowerCase()
    const mimeType =
      extension === 'png'
        ? 'image/png'
        : extension === 'jpg' || extension === 'jpeg'
        ? 'image/jpeg'
        : extension === 'pdf'
        ? 'application/pdf'
        : 'application/octet-stream'

    const file = new Blob([buffer], { type: mimeType })
    const fileUrl = window.URL.createObjectURL(file)

    const anchor = document.createElement('a')
    anchor.href = fileUrl
    anchor.download = fileName
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)

    setTimeout(() => URL.revokeObjectURL(fileUrl), 1000)
  })

export const getVehicleSendBackToCanada = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<VehicleSendBackToCanadaDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/send-back-to-canada`).then(response => response.data)

export const updateVehicleSendBackToCanada = (vehicleGuid: string, values: VehicleSendBackToCanadaDto) =>
  apiClient
    .put<ApiResponse<VehicleSendBackToCanadaDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/send-back-to-canada`, values)
    .then(response => response.data)

export const getVehicleInvoicing = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<VehicleInvoicingDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/invoicing`).then(response => response.data)

export const updateVehicleInvoicing = (vehicleGuid: string, values: VehicleInvoicingDto) =>
  apiClient.put<ApiResponse<VehicleInvoicingDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/invoicing`, values).then(response => response.data)

export const getVehicleReference = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<VehicleReferenceDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/reference`).then(response => response.data)

export const getVehicleTransactions = (vehicleGuid: string, parameters: VehicleTransactionParameters) =>
  apiClient
    .get<ApiResponse<VehicleTransactionDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/transactions` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

// export const createVehicleTransaction = (values: VehicleTransactionDto, vehicleGuid: string) =>
//   apiClient
//     .post<ApiResponse<VehicleTransactionDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/transactions`, values)
//     .then(response => response.data)

export const getVehicleImporterNotes = (vehicleGuid: string, parameters: VehicleImporterNoteParameters) =>
  apiClient
    .get<ApiResponse<VehicleImporterNoteDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/importer-notes` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const createImporterNote = (values: VehicleImporterNoteDto, vehicleId: string) =>
  apiClient.post<ApiResponse<VehicleImporterNoteDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/importer-notes`, values).then(res => res.data)

export const getVehicleExporterPhotos = (vehicleId: string) =>
  apiClient.get<ApiResponse<VehicleExporterPhotosDto>>(`/api/vehicles/${vehicleId}/exporter-photos`).then(response => response.data)

export const getVehicleExporterPhotosFile = (vehicleId: string, fileName: string) =>
  apiClient.get(`/api/vehicles/${vehicleId}/exporter-photos/${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const getVehicleDamagesByVehicleGuid = (vehicleGuid: string, parameters: VehicleDamageParameters) =>
  apiClient
    .get<ApiResponse<VehicleDamageDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/damages` + URIQuery({ ...parameters }))

    .then(response => response.data)

export const getVehicleDamageNotes = (vehicleGuid: string, damageGuid: string, parameters: VehicleDamageNoteParameters) =>
  apiClient
    .get<ApiResponse<VehicleDamageNoteDto[]>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/damage-details/${encodeURIComponent(damageGuid)}` + URIQuery({ ...parameters })
    )
    .then(response => response.data)

export const createVehicleDamageNote = (values: VehicleDamageNoteDto, vehicleGuid: string, damageGuid: string) =>
  apiClient
    .post<ApiResponse<VehicleDamageNoteDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/damage-details/${encodeURIComponent(damageGuid)}/damage-notes`,
      values
    )
    .then(response => response.data)

export const getManufacturerLabelImageExporterFile = (vehicleGuid: string, fileName: string) =>
  apiClient.get(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/exporter-photos/manufacturer-label-image/${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const getTPMSTelltaleImageExporterFile = (vehicleGuid: string, fileName: string) =>
  apiClient.get(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/exporter-photos/tpms-telltale-image/${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const getOdometerImageExporterFile = (vehicleGuid: string, fileName: string) =>
  apiClient.get(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/exporter-photos/odometer-image/${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const getVehicleParkingSpace = (vehicleId: string) =>
  apiClient.get<ApiResponse<VehicleParkingSpaceDto>>(`/api/vehicles/${vehicleId}/parking-space`).then(response => response.data)

export const updateVehicleParkingSpace = (vehicleId: string, values: VehicleParkingSpaceDto) =>
  apiClient.put<ApiResponse<VehicleParkingSpaceDto>>(`/api/vehicles/${vehicleId}/parking-space`, values).then(response => response.data)

export const getVehicleDocuments = (vehicleGuid: string, parameters: VehicleDocumentsParameters) =>
  apiClient
    .get<ApiResponse<VehicleDocumentDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/documents` + URIQuery({ ...parameters }))
    .then(response => response.data)

export const createVehicleDocument = (vehicleId: string, data: VehicleDocumentDto) => {
  return apiClient.post<ApiResponse<VehicleDocumentDto>>(`/api/vehicles/${vehicleId}/documents`, objectToFormData(data)).then(response => response.data)
}

export const getVehicleDocumentFile = (vehicleId: string, documentGuid: string, fileName: string) =>
  apiClient.get(`/api/vehicles/${vehicleId}/documents/${encodeURIComponent(documentGuid)}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer])
    const anchor = document.createElement('a')
    anchor.href = window.URL.createObjectURL(file)
    anchor.download = fileName
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    // Uncomment below if you want to open file in new tab instead of download.
    // Maxwell Sommer 09/27/2024
    // const buffer = base64ToArrayBuffer(response.data)
    // const file = new Blob([buffer], { type: 'image/png' })
    // const fileUrl = window.URL.createObjectURL(file)
    // const _newTab = window.open(fileUrl)
  })

export const getVehicleDocumentBase64 = (vehicleId: string, documentGuid: string) =>
  apiClient.get<string>(`/api/vehicles/${vehicleId}/documents/${encodeURIComponent(documentGuid)}`).then(response => response.data)

export const getVehicleDocumentFileName = (vehicleGuid: string, fileName: string) =>
  apiClient.get(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/documents/${encodeURIComponent(fileName)}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer])
    const anchor = document.createElement('a')
    anchor.href = window.URL.createObjectURL(file)
    anchor.download = fileName
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  })

export const deleteVehicleDocuments = (vehicleId: string, dtos: VehicleDocumentDto[]) =>
  apiClient.delete(`/api/vehicles/${vehicleId}/documents`, { data: dtos }).then(response => response.data)

export const deleteVehicleTransaction = (vehicleGuid: string, vehicleTransactionGuid: string) =>
  apiClient
    .delete(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/transactions/${encodeURIComponent(vehicleTransactionGuid)}`)
    .then(response => response.data)

export const updateVehicleExporterPhotos = (vehicleId: string, values: VehicleExporterPhotosDto) => {
  const payload = new FormData()

  const { manufacturerLabelImageExporterFile, tpmsTelltaleImageExporterFile, odometerImageExporterFile, ...rest } = values

  payload.append('vehicleExporterPhotosDto', JSON.stringify(rest))
  payload.append('manufacturerLabelImageExporterFile', manufacturerLabelImageExporterFile!)
  payload.append('tpmsTellTaleImageExporterFile', tpmsTelltaleImageExporterFile!)
  payload.append('odometerImageExporterFile', odometerImageExporterFile!)

  return apiClient<ApiResponse<VehicleExporterPhotosDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleId)}/exporter-photos`
  }).then(response => response.data)
}

export const getVehicleCheckInDetails = (vehicleId: string) =>
  apiClient.get<ApiResponse<VehicleCheckInDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/vehicle-check-in`).then(response => response.data)

// export const getNeedsClusterReinstalledDetails = (vehicleId: string) =>
//   apiClient
//     .get<ApiResponse<NeedsClusterReinstalledDetailsDto>>(
//       `/api/vehicles/${encodeURIComponent(vehicleId)}/needs-cluster-reinstalled`
//     )
//     .then(response => response.data)

export const getNeedsClusterReinstalledDetails = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterReinstalledDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/needs-cluster-reinstalled`)
    .then(response => response.data)

export const updateVehicleCheckInDetails = (vehicleGuid: string, values: VehicleCheckInDetailsDto) =>
  apiClient
    .put<ApiResponse<VehicleCheckInDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in`, values)
    .then(response => response.data)

export const updateNeedsClusterReinstalledDetails = (vehicleGuid: string, values: NeedsClusterReinstalledDetailsDto) =>
  apiClient
    .put<ApiResponse<NeedsClusterReinstalledDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled`, values)
    .then(response => response.data)

export const sendMileageDiscrepancyEmail = (vehicleGuid: string) =>
  apiClient.post(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/send-mileage-discrepancy-email`).then(response => response.data)

export const getVehicleCheckInCurrent = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInCurrentDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/vehicle-check-in-current`)
    .then(response => response.data)

export const getVehicleCheckInManufacturersLabelPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInManufacturersLabelPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/manufacturers-label-photo/`)
    .then(response => response.data)

// #region Manufacturer's Label
export const updateVehicleCheckInManufacturersLabelPhotoInformation = (vehicleGuid: string, values: VehicleCheckInManufacturersLabelPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInManufacturersLabelPhotoFile) {
    payload.append('vehicleCheckInManufacturersLabelPhotoFile', values.vehicleCheckInManufacturersLabelPhotoFile)
  }

  if (values.vehicleCheckInIsManufacturersLabelPhotoMissing) {
    payload.append('vehicleCheckInIsManufacturersLabelPhotoMissing', values.vehicleCheckInIsManufacturersLabelPhotoMissing.toString())
  }

  if (values.vehicleCheckInManufacturersLabelMissingNote) {
    payload.append('vehicleCheckInManufacturersLabelMissingNote', values.vehicleCheckInManufacturersLabelMissingNote)
  }

  return apiClient<ApiResponse<VehicleCheckInManufacturersLabelPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/manufacturers-label-photo/`
  }).then(response => response.data)
}

export const deleteVehicleCheckInManufacturersLabelPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInManufacturersLabelPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/manufacturers-label-photo`
    )
    .then(response => response.data)
// #endregion

// #region Tire Pressure Label
export const getVehicleCheckInTirePressureLabelPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInTirePressureLabelPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/tire-pressure-label-photo`)
    .then(response => response.data)

export const updateVehicleCheckInTirePressureLabelPhotoInformation = (vehicleGuid: string, values: VehicleCheckInTirePressureLabelPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInTirePressureLabelPhotoFile) {
    payload.append('vehicleCheckInTirePressureLabelPhotoFile', values.vehicleCheckInTirePressureLabelPhotoFile)
  }

  if (values.vehicleCheckInIsTirePressureLabelPhotoMissing) {
    payload.append('vehicleCheckInIsTirePressureLabelPhotoMissing', values.vehicleCheckInIsTirePressureLabelPhotoMissing.toString())
  }

  if (values.vehicleCheckInTirePressureLabelMissingNote) {
    payload.append('vehicleCheckInTirePressureLabelMissingNote', values.vehicleCheckInTirePressureLabelMissingNote)
  }

  return apiClient<ApiResponse<VehicleCheckInTirePressureLabelPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/tire-pressure-label-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInTirePressureLabelPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInTirePressureLabelPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/tire-pressure-label-photo`)
    .then(response => response.data)
// #endregion

// #region Importer Door Label
export const getVehicleCheckInImporterDoorLabelPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInImporterDoorLabelPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/importer-door-label-photo`)
    .then(response => response.data)

export const updateVehicleCheckInImporterDoorLabelPhotoInformation = (vehicleGuid: string, values: VehicleCheckInImporterDoorLabelPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInImporterDoorLabelPhotoFile) {
    payload.append('vehicleCheckInImporterDoorLabelPhotoFile', values.vehicleCheckInImporterDoorLabelPhotoFile)
  }

  return apiClient<ApiResponse<VehicleCheckInImporterDoorLabelPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/importer-door-label-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInImporterDoorLabelPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInImporterDoorLabelPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/importer-door-label-photo`)
    .then(response => response.data)
// #endregion

// #region Combo
export const getVehicleCheckInComboPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInComboPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/combo-photo/`)
    .then(response => response.data)

export const getVehicleCheckInComboPhotoFile = (vehicleGuid: string, fileName: string) =>
  apiClient.get(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/combo-photo/${fileName}`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'image/png' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const updateVehicleCheckInComboPhotoInformation = (vehicleGuid: string, values: VehicleCheckInComboPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInComboPhotoFile) {
    payload.append('vehicleCheckInComboPhotoFile', values.vehicleCheckInComboPhotoFile)
  }

  return apiClient<ApiResponse<VehicleCheckInComboPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/combo-photo/`
  })
    .then(response => response.data)
    .catch(e => {
      throw e
    })
}

export const deleteVehicleCheckInComboPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInComboPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/combo-photo`)
    .then(response => response.data)
// #endregion

// #region Check-In Cluster
export const getVehicleCheckInCheckInClusterPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInCheckInClusterPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/check-in-cluster-photo`)
    .then(response => response.data)

export const updateVehicleCheckInCheckInClusterPhotoInformation = (vehicleGuid: string, values: VehicleCheckInCheckInClusterPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInCheckInClusterPhotoFile) {
    payload.append('vehicleCheckInCheckInClusterPhotoFile', values.vehicleCheckInCheckInClusterPhotoFile)
  }

  payload.append(
    'alsoUseForOdometerBeforeModificationPhoto',
    String(values.alsoUseForOdometerBeforeModificationPhoto ?? true)
  )

  return apiClient<ApiResponse<VehicleCheckInCheckInClusterPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/check-in-cluster-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInCheckInClusterPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInCheckInClusterPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/check-in-cluster-photo`)
    .then(response => response.data)
// #endregion

// #region Cluster with Odometer
export const getVehicleCheckInClusterWithOdometerPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInClusterWithOdometerPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/cluster-with-odometer-photo`
    )
    .then(response => response.data)

export const updateVehicleCheckInClusterWithOdometerPhotoInformation = (vehicleGuid: string, values: VehicleCheckInClusterWithOdometerPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInClusterWithOdometerPhotoFile) {
    payload.append('vehicleCheckInClusterWithOdometerPhotoFile', values.vehicleCheckInClusterWithOdometerPhotoFile)
  }

  return apiClient<ApiResponse<VehicleCheckInClusterWithOdometerPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/cluster-with-odometer-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInClusterWithOdometerPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInClusterWithOdometerPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/cluster-with-odometer-photo`
    )
    .then(response => response.data)
// #endregion

// #region Driver Airbag
export const getVehicleCheckInDriverAirbagPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInDriverAirbagPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/driver-airbag-photo`)
    .then(response => response.data)

export const updateVehicleCheckInDriverAirbagPhotoInformation = (vehicleGuid: string, values: VehicleCheckInDriverAirbagPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInDriverAirbagPhotoFile) {
    payload.append('vehicleCheckInDriverAirbagPhotoFile', values.vehicleCheckInDriverAirbagPhotoFile)
  }

  return apiClient<ApiResponse<VehicleCheckInDriverAirbagPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/driver-airbag-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInDriverAirbagPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInDriverAirbagPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/driver-airbag-photo`)
    .then(response => response.data)
// #endregion

// #region Backup Cam
export const getVehicleCheckInBackupCamPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInBackupCamPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/backup-cam-photo`)
    .then(response => response.data)

export const updateVehicleCheckInBackupCamPhotoInformation = (vehicleGuid: string, values: VehicleCheckInBackupCamPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInBackupCamPhotoFile) {
    payload.append('vehicleCheckInBackupCamPhotoFile', values.vehicleCheckInBackupCamPhotoFile)
  }

  if (values.vehicleCheckInHasBackupCam !== undefined) {
    payload.append('vehicleCheckInHasBackupCam', values.vehicleCheckInHasBackupCam.toString())
  }

  return apiClient<ApiResponse<VehicleCheckInBackupCamPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/backup-cam-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInBackupCamPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInBackupCamPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/backup-cam-photo`)
    .then(response => response.data)
// #endregion

// #region Airbag tell-tale
export const getVehicleCheckInAirbagTellTalePhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInAirbagTellTalePhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/airbag-tell-tale-photo`)
    .then(response => response.data)

export const updateVehicleCheckInAirbagTellTalePhotoInformation = (vehicleGuid: string, values: VehicleCheckInAirbagTellTalePhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInAirbagTellTalePhotoFile) {
    payload.append('vehicleCheckInAirbagTellTalePhotoFile', values.vehicleCheckInAirbagTellTalePhotoFile)
  }

  if (values.vehicleCheckInAirbagTellTalePhotoType) {
    payload.append('vehicleCheckInAirbagTellTalePhotoType', values.vehicleCheckInAirbagTellTalePhotoType)
  }

  return apiClient<ApiResponse<VehicleCheckInAirbagTellTalePhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/airbag-tell-tale-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInAirbagTellTalePhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInAirbagTellTalePhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/airbag-tell-tale-photo`)
    .then(response => response.data)
// #endregion

// #region Passenger Airbag
export const getVehicleCheckInPassengerAirbagPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInPassengerAirbagPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/passenger-airbag-photo`)
    .then(response => response.data)

export const updateVehicleCheckInPassengerAirbagPhotoInformation = (vehicleGuid: string, values: VehicleCheckInPassengerAirbagPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInPassengerAirbagPhotoFile) {
    payload.append('vehicleCheckInPassengerAirbagPhotoFile', values.vehicleCheckInPassengerAirbagPhotoFile)
  }

  if (values.vehicleCheckInHasPassengerAirbag) {
    payload.append('vehicleCheckInHasPassengerAirbag', values.vehicleCheckInHasPassengerAirbag.toString())
  }

  return apiClient<ApiResponse<VehicleCheckInPassengerAirbagPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/passenger-airbag-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInPassengerAirbagPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInPassengerAirbagPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/passenger-airbag-photo`)
    .then(response => response.data)
// #endregion

// #region VIN on Dashboard
export const getVehicleCheckInVINOnDashboardPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInVINOnDashboardPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/vin-on-dashboard-photo`)
    .then(response => response.data)

export const updateVehicleCheckInVINOnDashboardPhotoInformation = (vehicleGuid: string, values: VehicleCheckInVINOnDashboardPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInVINOnDashboardPhotoFile) {
    payload.append('vehicleCheckInVINOnDashboardPhotoFile', values.vehicleCheckInVINOnDashboardPhotoFile)
  }

  return apiClient<ApiResponse<VehicleCheckInVINOnDashboardPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/vin-on-dashboard-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInVINOnDashboardPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInVINOnDashboardPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/vin-on-dashboard-photo`)
    .then(response => response.data)
// #endregion

// #region Roof
export const getVehicleCheckInRoofPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInRoofPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/roof-photo`)
    .then(response => response.data)

export const updateVehicleCheckInRoofPhotoInformation = (vehicleGuid: string, values: VehicleCheckInRoofPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInRoofPhotoFile) {
    payload.append('vehicleCheckInRoofPhotoFile', values.vehicleCheckInRoofPhotoFile)
  }

  return apiClient<ApiResponse<VehicleCheckInRoofPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/roof-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInRoofPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInRoofPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/roof-photo`)
    .then(response => response.data)
// #endregion

// #region Front corner
export const getVehicleCheckInFrontCornerPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInFrontCornerPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/front-corner-photo`)
    .then(response => response.data)

export const updateVehicleCheckInFrontCornerPhotoInformation = (vehicleGuid: string, values: VehicleCheckInFrontCornerPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInFrontCornerPhotoFile) {
    payload.append('vehicleCheckInFrontCornerPhotoFile', values.vehicleCheckInFrontCornerPhotoFile!)
  }

  return apiClient<ApiResponse<VehicleCheckInFrontCornerPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/front-corner-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInFrontCornerPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInFrontCornerPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/front-corner-photo`)
    .then(response => response.data)
// #endregion

// #region Front head on
export const getVehicleCheckInFrontHeadOnPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInFrontHeadOnPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/front-head-on-photo`)
    .then(response => response.data)

export const updateVehicleCheckInFrontHeadOnPhotoInformation = (vehicleGuid: string, values: VehicleCheckInFrontHeadOnPhotoDto) => {
  const payload = new FormData()

  payload.append('vehicleCheckInFrontHeadOnPhotoFile', values.vehicleCheckInFrontHeadOnPhotoFile!)

  return apiClient<ApiResponse<VehicleCheckInFrontHeadOnPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/front-head-on-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInFrontHeadOnPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInFrontHeadOnPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/front-head-on-photo`)
    .then(response => response.data)
// #endregion

// #region Rear corner
export const getVehicleCheckInRearCornerPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInRearCornerPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/rear-corner-photo`)
    .then(response => response.data)

export const updateVehicleCheckInRearCornerPhotoInformation = (vehicleGuid: string, values: VehicleCheckInRearCornerPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInRearCornerPhotoFile) {
    payload.append('vehicleCheckInRearCornerPhotoFile', values.vehicleCheckInRearCornerPhotoFile)
  }

  return apiClient<ApiResponse<VehicleCheckInRearCornerPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/rear-corner-photo`
  }).then(response => response.data)
}

export const deleteVehicleCheckInRearCornerPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInRearCornerPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/rear-corner-photo`)
    .then(response => response.data)
// #endregion

// #region Rear head on
export const getVehicleCheckInRearHeadOnPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInRearHeadOnPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/rear-head-on-photo`)
    .then(response => response.data)

export const updateVehicleCheckInRearHeadOnPhotoInformation = (vehicleGuid: string, values: VehicleCheckInRearHeadOnPhotoDto) => {
  const payload = new FormData()

  if (values.vehicleCheckInRearHeadOnPhotoFile) {
    payload.append('vehicleCheckInRearHeadOnPhotoFile', values.vehicleCheckInRearHeadOnPhotoFile!)
  }

  return apiClient<ApiResponse<VehicleCheckInRearHeadOnPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/rear-head-on-photo`
  })
    .then(response => response.data)
    .catch(e => {
      throw e
    })
}

export const deleteVehicleCheckInRearHeadOnPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleCheckInRearHeadOnPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/rear-head-on-photo`)
    .then(response => response.data)
// #endregion

export const getManufacturerLabelDateInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInManufacturerLabelDatesDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/manufacturer-label-dates`)
    .then(response => response.data)

export const updateManufacturerLabelDateInformation = (vehicleGuid: string, values: VehicleCheckInManufacturerLabelDatesDto) =>
  apiClient
    .put<ApiResponse<VehicleCheckInManufacturerLabelDatesDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/manufacturer-label-dates`,
      values
    )
    .then(response => response.data)

export const getTirePressureLabelDateInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleCheckInTirePressureLabelDatesDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/tire-pressure-label-dates`)
    .then(response => response.data)

export const updateTirePressureLabelDateInformation = (vehicleGuid: string, values: VehicleCheckInTirePressureLabelDatesDto) =>
  apiClient
    .put<ApiResponse<VehicleCheckInTirePressureLabelDatesDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/vehicle-check-in/tire-pressure-label-dates`,
      values
    )
    .then(response => response.data)

export const getNeedsOEMSiteCheckedForRecallsToDoList = (parameters: ToDoListNeedsOEMSiteCheckedForRecallsParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-oem-site-checked-for-recalls' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsCaRoUploadedToDoList = (parameters: ToDoListNeedsCaRoUploadedParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-ca-ro-uploaded' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsBWIApprovalToDoList = (parameters: ToDoListNeedsBWIApprovalParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-bwi-approval' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsToBeAddedToPAPSToDoList = (parameters: ToDoListNeedsToBeAddedToPAPSParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-to-be-added-to-paps' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getCancelledToDoList = (parameters: ToDoListCanceledParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/cancelled' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsSignedForiegnShipperToDoList = (parameters: ToDoListNeedsSignedForeignShipperParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-signed-foreign-shipper' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsSpecialBondToDoList = (parameters: ToDoListNeedsSpecialBondParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-special-bond' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsManufacturerLabelExporterToDoList = (parameters: ToDoListNeedsManufacturerLabelExporterParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-manufacturer-label-exporter' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsTMPSLabelExporterToDoList = (parameters: ToDoListNeedsTMPSLabelExporterParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-tmps-label-exporter' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsBrokerDocumentsToDoList = (parameters: ToDoListNeedsBrokerDocumentsParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-broker-documents' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getWaitingOnTripToDoList = (parameters: ToDoListWaitingOnTripParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/waiting-on-trip' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsManufacturerLabelToDoList = (parameters: ToDoListNeedsManufacturerLabelParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-manufacturer-label' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsTirePressureLabelToDoList = (parameters: ToDoListNeedsTirePressureLabelParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-tire-pressure-label' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsTMPSLabelToDoList = (parameters: ToDoListNeedsTMPSLabelParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-tmps-label' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsPhotoToDoList = (parameters: ToDoListNeedsPhotoParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-photo' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsCheckInToDoList = (parameters: ToDoListNeedsCheckInParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-check-in' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsTripInfoToDoList = (parameters: ToDoListNeedsTripInfoParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-trip-info' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsRecallDocsToDoList = (parameters: ToDoListNeedsRecallDocsParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-recall-docs' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsRecallWorkToDoList = (parameters: ToDoListNeedsRecallWorkParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-recall-work' + URIQuery({ ...parameters })).then(({ data }) => data)

// #region Needs Cluster Removed
export const getNeedsClusterRemovedToDoList = (parameters: ToDoListNeedsClusterRemovedParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-cluster-removed' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsClusterRemovedDetails = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterRemovedDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/needs-cluster-removed`)
    .then(response => response.data)

export const updateNeedsClusterRemovedDetails = (vehicleId: string, values: NeedsClusterRemovedDetailsDto) =>
  apiClient
    .put<ApiResponse<NeedsClusterRemovedDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/needs-cluster-removed`, values)
    .then(response => response.data)

export const getNeedsClusterRemovedSearch = (search: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterRemovedDetailsDto | undefined>>('/api/vehicles/search-cluster-removed?search=' + encodeURIComponent(search))
    .then(response => response.data)

export const getNeedsClusterRemovedPulledClusterPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterRemovedPulledClusterPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-removed/pulled-cluster-photo`)
    .then(response => response.data)

export const updateNeedsClusterRemovedPulledClusterPhotoInformation = (vehicleGuid: string, values: NeedsClusterRemovedPulledClusterPhotoDto) => {
  const payload = new FormData()

  if (values.clusterPhotosPulledClusterPhotoFile) {
    payload.append('clusterPhotosPulledClusterPhotoFile', values.clusterPhotosPulledClusterPhotoFile)
  }

  if (values.clusterPhotosPulledClusterPhotoNote) {
    payload.append('clusterPhotosPulledClusterPhotoNote', values.clusterPhotosPulledClusterPhotoNote)
  }

  return apiClient<ApiResponse<NeedsClusterRemovedPulledClusterPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-removed/pulled-cluster-photo`
  }).then(response => response.data)
}

export const deleteNeedsClusterRemovedPulledClusterPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<NeedsClusterRemovedPulledClusterPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-removed/pulled-cluster-photo`
    )
    .then(response => response.data)

export const startClusterRemoval = (vehicleGuid: string) =>
  apiClient.put<undefined>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/start-cluster-removal`).then(() => {})
// #endregion

export const getNeedsClusterConversionShipperToDoList = (parameters: ToDoListNeedsClusterConversionShipperParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-cluster-conversion-shipper' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsClusterDeliveredToThirdPartyConversionCompanyToDoList = (
  parameters: ToDoListNeedsClusterDeliveredToThirdPartyConversionCompanyParameters
) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-cluster-delivered-to-third-party-conversion-company' + URIQuery({ ...parameters }))
    .then(({ data }) => data)

// #region Waiting on Third Party Cluster Conversion Company
export const getWaitingOnThirdPartyClusterConversionCompanyDetails = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleWaitingOnThirdPartyConversionCompanyDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleId)}/waiting-on-third-party-cluster-conversion-company`
    )
    .then(response => response.data)

export const updateWaitingOnThirdPartyClusterConversionCompanyDetails = (vehicleGuid: string, values: VehicleWaitingOnThirdPartyConversionCompanyDetailsDto) =>
  apiClient
    .put<ApiResponse<VehicleWaitingOnThirdPartyConversionCompanyDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/waiting-on-third-party-cluster-conversion-company`,
      values
    )
    .then(response => response.data)

export const getWaitingOnThirdPartyClusterConversionCompanySearch = (search: string) =>
  apiClient
    .get<ApiResponse<VehicleWaitingOnThirdPartyConversionCompanyDetailsDto | undefined>>(
      '/api/vehicles/search-waiting-on-third-party-conversion-company?search=' + encodeURIComponent(search)
    )
    .then(response => response.data)
// #endregion

// #region Needs Cluster Conversion In-House
export const getNeedsClusterConversionInHouseDetails = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleNeedsClusterConversionInHouseDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/needs-cluster-conversion-in-house`)
    .then(response => response.data)

export const updateNeedsClusterConversionInHouseDetails = (vehicleId: string, values: VehicleNeedsClusterConversionInHouseDetailsDto) =>
  apiClient
    .put<ApiResponse<VehicleNeedsClusterConversionInHouseDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleId)}/needs-cluster-conversion-in-house`,
      values
    )
    .then(response => response.data)

export const getNeedsClusterConversionInHouseSearch = (search: string) =>
  apiClient
    .get<ApiResponse<VehicleNeedsClusterConversionInHouseDetailsDto | undefined>>(
      '/api/vehicles/search-needs-cluster-conversion-in-house?search=' + encodeURIComponent(search)
    )
    .then(response => response.data)
// #endregion

// #region Needs In-House Additional Programming
export const getNeedsInHouseAdditionalProgrammingDetails = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleNeedsInHouseAdditionalProgrammingDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleId)}/needs-in-house-additional-programming`
    )
    .then(response => response.data)

export const updateNeedsInHouseAdditionalProgrammingDetails = (vehicleId: string, values: VehicleNeedsInHouseAdditionalProgrammingDetailsDto) =>
  apiClient
    .put<ApiResponse<VehicleNeedsInHouseAdditionalProgrammingDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleId)}/needs-in-house-additional-programming`,
      values
    )
    .then(response => response.data)

export const getNeedsInHouseAdditionalProgrammingSearch = (search: string) =>
  apiClient
    .get<ApiResponse<VehicleNeedsInHouseAdditionalProgrammingDetailsDto | undefined>>(
      '/api/vehicles/search-needs-in-house-additional-programming?search=' + encodeURIComponent(search)
    )
    .then(response => response.data)
// #endregion

// #region Needs Third Party Additional Programming
export const getNeedsThirdPartyAdditionalProgrammingDetails = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleNeedsThirdPartyAdditionalProgrammingDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleId)}/needs-third-party-additional-programming`
    )
    .then(response => response.data)

export const updateNeedsThirdPartyAdditionalProgrammingDetails = (vehicleId: string, values: VehicleNeedsThirdPartyAdditionalProgrammingDetailsDto) =>
  apiClient
    .put<ApiResponse<VehicleNeedsThirdPartyAdditionalProgrammingDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleId)}/needs-third-party-additional-programming`,
      values
    )
    .then(response => response.data)

export const getNeedsThirdPartyAdditionalProgrammingSearch = (search: string) =>
  apiClient
    .get<ApiResponse<VehicleNeedsThirdPartyAdditionalProgrammingDetailsDto | undefined>>(
      '/api/vehicles/search-needs-third-party-additional-programming?search=' + encodeURIComponent(search)
    )
    .then(response => response.data)
// #endregion

// #region Waiting on Third Party Additional Programming
export const getWaitingOnThirdPartyAdditionalProgrammingDetails = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<VehicleWaitingOnThirdPartyAdditionalProgrammingDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleId)}/waiting-on-third-party-additional-programming`
    )
    .then(response => response.data)

export const updateWaitingOnThirdPartyAdditionalProgrammingDetails = (vehicleId: string, values: VehicleWaitingOnThirdPartyAdditionalProgrammingDetailsDto) =>
  apiClient
    .put<ApiResponse<VehicleWaitingOnThirdPartyAdditionalProgrammingDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleId)}/waiting-on-third-party-additional-programming`,
      values
    )
    .then(response => response.data)

export const getWaitingOnThirdPartyAdditionalProgrammingSearch = (search: string) =>
  apiClient
    .get<ApiResponse<VehicleWaitingOnThirdPartyAdditionalProgrammingDetailsDto | undefined>>(
      '/api/vehicles/search-waiting-on-third-party-additional-programming?search=' + encodeURIComponent(search)
    )
    .then(response => response.data)
// #endregion

export const getNeedsClusterReinstalledToDoList = (parameters: ToDoListNeedsClusterReinstalledParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/needs-cluster-reinstalled' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsIncorrectMileageResolutionToDoList = (parameters: ToDoListNeedsIncorrectMileageResolutionParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-incorrect-mileage-resolution' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsShipperConversionToDoList = (parameters: ToDoListNeedsShipperConversionParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-shipper-conversion' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getWaitingOnConversionToDoList = (parameters: ToDoListWaitingOnConversionParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/waiting-on-conversion' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsClusterProgrammingToDoList = (parameters: ToDoListNeedsClusterProgrammingParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-cluster-programming' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsShipperProgrammingToDoList = (parameters: ToDoListNeedsShipperProgrammingParameters) =>
  apiClient.get<ApiResponse<VehicleDto[]>>('/api/vehicles/to-do-list/needs-shipper-programming' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getWaitingOnProgrammingToDoList = (parameters: ToDoListWaitingOnProgrammmingParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehcile/to-do-list/waiting-on-programming' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsConformityPhotosToDoList = (parameters: ToDoListNeedsConformityPhotosParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/needs-conformity-photos' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsConformitySentToDOTToDoList = (parameters: ToDoListNeedsConformitySentToDOTParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/needs-comformity-sent-to-dot' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getConformitySentToDOTHoldToDoList = (parameters: ToDoListConformitySentToDOTHoldParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsOutboundPhotosToDoList = (parameters: ToDoListNeedsOutboundPhotosParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehcile/to-do-list/needs-outbound-photos' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsBOLInVehicleToDoList = (parameters: ToDoListNeedsBOLInVehicleParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/needs-bol-in-vehicle' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsToBeShippedOutboundToDoList = (parameters: ToDoListNeedsToBeShippedOutboundParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/needs-to-be-shipped-outbound' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsInvoiceToDoList = (parameters: ToDoListNeedsInvoiceParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/needs-invoice' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getOhioTitlesToDoList = (parameters: ToDoListOhioTitlesParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/ohio' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getWMAAToDoList = (parameters: ToDoListWMAAParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/WMAA' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getMichiganTitlesToDoList = (parameters: ToDoListMichiganTitlesParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/michigan' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getOutgoingTitlesToDoList = (parameters: ToDoListOutgoingTitlesParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/outgoing-title' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getMissouriTitlesToDoList = (parameters: ToDoListMissouriTitlesParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/missouri-titles' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNeedsDamageRepairToDoList = (parameters: ToDoListNeedsDamageRepairedParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/needs-dmage-repair' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getVehicleOnLotToDoList = (parameters: ToDoListVehicleOnLotParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/vehicle-on-lot' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getNoCANOwnershipToDoList = (parameters: ToDoListNoCANOwnershipParameters) =>
  apiClient.get<ApiResponse<VehicleDto>>('api/vehicle/to-do-list/no-can-ownership' + URIQuery({ ...parameters })).then(({ data }) => data)

export const createVehicleRecallCampaign = (values: VehicleRecallDto, vehicleGuid: string) => {
  const payload = new FormData()

  if (values.vehicleRecallStatus) {
    if (values.vehicleRecallStatus.vehicleRecallStatusGuid) {
      payload.append('vehicleRecallStatus.vehicleRecallStatusGuid', values.vehicleRecallStatus.vehicleRecallStatusGuid)
    }
  }
  if (values.recallCampaignId) {
    payload.append('recallCampaignId', values.recallCampaignId)
  }
  if (values.recallDescription) {
    payload.append('recallDescription', values.recallDescription)
  }
  if (values.recallCountry) {
    payload.append('recallCountry', values.recallCountry)
  }
  if (values.repairCountry) {
    payload.append('repairCountry', values.repairCountry)
  }
  if (values.repairLocationAddress) {
    if (values.repairLocationAddress.addressGuid) {
      payload.append('repairLocationAddress.addressGuid', values.repairLocationAddress.addressGuid)
    }
  }
  if (values.vehicleRecallRepairStatus) {
    if (values.vehicleRecallRepairStatus.vehicleRecallRepairStatusGuid) {
      payload.append('vehicleRecallRepairStatus.vehicleRecallRepairStatusGuid', values.vehicleRecallRepairStatus.vehicleRecallRepairStatusGuid)
    }
  }
  if (values.canadianOEMSiteURL) {
    payload.append('canadianOEMSiteURL', values.canadianOEMSiteURL)
  }
  if (values.usaOEMSiteURL) {
    payload.append('usaOEMSiteURL', values.usaOEMSiteURL)
  }
  if (values.canadianOEMSiteScreenshotFile) {
    payload.append('canadianOEMSiteScreenshotFile', values.canadianOEMSiteScreenshotFile)
  }
  if (values.usaOEMSiteScreenshotFile) {
    payload.append('usaOEMSiteScreenshotFile', values.usaOEMSiteScreenshotFile)
  }
  if (values.repairOrderFile) {
    payload.append('repairOrderFile', values.repairOrderFile)
  }

  return apiClient<ApiResponse<VehicleRecallDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/recall-campaigns`
  }).then(response => response.data)
}

export const updateVehicleRecallCampaign = (values: VehicleRecallDto, vehicleGuid: string) => {
  const payload = new FormData()

  if (values.vehicleRecallGuid) {
    payload.append('vehicleRecallGuid', values.vehicleRecallGuid)
  }
  if (values.vehicleRecallStatus) {
    if (values.vehicleRecallStatus.vehicleRecallStatusGuid) {
      payload.append('vehicleRecallStatus.vehicleRecallStatusGuid', values.vehicleRecallStatus.vehicleRecallStatusGuid)
    }
  }
  if (values.recallCampaignId) {
    payload.append('recallCampaignId', values.recallCampaignId)
  }
  if (values.recallDescription) {
    payload.append('recallDescription', values.recallDescription)
  }
  if (values.recallCountry) {
    payload.append('recallCountry', values.recallCountry)
  }
  if (values.repairCountry) {
    payload.append('repairCountry', values.repairCountry)
  }
  if (values.repairLocationAddress) {
    if (values.repairLocationAddress.addressGuid) {
      payload.append('repairLocationAddress.addressGuid', values.repairLocationAddress.addressGuid)
    }
  }
  if (values.vehicleRecallRepairStatus) {
    if (values.vehicleRecallRepairStatus.vehicleRecallRepairStatusGuid) {
      payload.append('vehicleRecallRepairStatus.vehicleRecallRepairStatusGuid', values.vehicleRecallRepairStatus.vehicleRecallRepairStatusGuid)
    }
  }
  if (values.canadianOEMSiteURL) {
    payload.append('canadianOEMSiteURL', values.canadianOEMSiteURL)
  }
  if (values.usaOEMSiteURL) {
    payload.append('usaOEMSiteURL', values.usaOEMSiteURL)
  }
  if (values.canadianOEMSiteScreenshotFile) {
    payload.append('canadianOEMSiteScreenshotFile', values.canadianOEMSiteScreenshotFile)
  }
  if (values.usaOEMSiteScreenshotFile) {
    payload.append('usaOEMSiteScreenshotFile', values.usaOEMSiteScreenshotFile)
  }
  if (values.repairOrderFile) {
    payload.append('repairOrderFile', values.repairOrderFile)
  }

  return apiClient<ApiResponse<VehicleRecallDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/recall-campaigns`
  }).then(response => response.data)
}

export const getVehicleRecallCampaigns = (vehicleGuid: string, parameters: VehicleRecallParameters) =>
  apiClient
    .get<ApiResponse<VehicleRecallDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/recall-campaigns` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const getVehicleRecallNotes = (vehicleGuid: string, parameters: VehicleRecallNoteParameters) =>
  apiClient
    .get<ApiResponse<VehicleRecallNoteDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/recall-notes` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const createVehicleRecallNote = (values: VehicleRecallNoteDto, vehicleId: string) =>
  apiClient.post<ApiResponse<VehicleRecallNoteDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/recall-notes`, values).then(res => res.data)

export const getClusterInformation = (vehicleId: string) =>
  apiClient.get<ApiResponse<VehicleClusterInformationDto>>(`/api/vehicles/${vehicleId}/cluster-information`).then(response => response.data)

export const updateClusterInformation = (vehicleGuid: string, values: VehicleClusterInformationDto, cancelToken?: CancelToken) =>
  apiClient
    .put<ApiResponse<VehicleClusterInformationDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/cluster-information`, values, { cancelToken })
    .then(response => response?.data)

export const getIncorrectMileageResolution = (vehicleId: string) =>
  apiClient.get<ApiResponse<VehicleIncorrectMileageResolutionDto>>(`/api/vehicles/${vehicleId}/incorrect-mileage-resolution`).then(response => response.data)

export const updateIncorrectMileageResolution = (vehicleGuid: string, values: VehicleIncorrectMileageResolutionDto) =>
  apiClient
    .put<ApiResponse<VehicleIncorrectMileageResolutionDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/incorrect-mileage-resolution`, values)
    .then(response => response.data)

export const getClusterTimeline = (vehicleId: string) =>
  apiClient.get<ApiResponse<VehicleClusterTimelineDto>>(`/api/vehicles/${vehicleId}/cluster-timeline`).then(response => response.data)

export const getVehicleDamage = (vehicleGuid: string, parameters: VehicleDamageParameters) =>
  apiClient
    .get<ApiResponse<VehicleDamageDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/damage` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const getDamageDetails = (vehicleGuid: string, damageGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleDamageDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/damage-details/${encodeURIComponent(damageGuid)}/damage-details`
    )
    .then(response => response.data)

export const updateDamageDetails = (vehicleGuid: string, damageGuid: string, values: VehicleDamageDetailsDto, cancelToken?: CancelToken) =>
  apiClient
    .put<ApiResponse<VehicleDamageDetailsDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/damage-details/${encodeURIComponent(damageGuid)}/damage-details`,
      values,
      { cancelToken }
    )
    .then(response => response?.data)

export const getDamageNotes = (vehicleGuid: string, damageGuid: string, parameters: VehicleDamageNoteParameters) =>
  apiClient
    .get<ApiResponse<VehicleDamageNoteDto[]>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/damage-details/${encodeURIComponent(damageGuid)}/damage-notes` + URIQuery({ ...parameters })
    )
    .then(({ data }) => data)

export const getDamagePhotos = (vehicleGuid: string, damageGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleDamagePhotosDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/damage-details/${encodeURIComponent(damageGuid)}/damage-photos`)
    .then(response => response.data)

export const getActivityLogs = (vehicleGuid: string, parameters: VehicleActivityLogParameters) =>
  apiClient
    .get<ApiResponse<VehicleActivityLogDto[]>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/activity-log` + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const createActivityLog = (values: VehicleActivityLogDto, vehicleId: string) =>
  apiClient
    .post<ApiResponse<VehicleActivityLogDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/activity-log`, values)
    .then(res => res.data)
    .catch(err => {
      console.error(err)
    })

// #region Needs Cluster Reinstalled Cluster With Odometer Label
export const getVehicleOdometerAfterModificationPhoto = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<VehicleOdometerAfterModificationPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/odometer-after-modification-photo`
    )
    .then(response => response.data)

export const updateVehicleOdometerAfterModificationPhoto = (
  vehicleGuid: string,
  values: VehicleOdometerAfterModificationPhotoDto
) => {
  const payload = new FormData()

  if (values.photoFile) {
    payload.append('photoFile', values.photoFile)
  }

  return apiClient<ApiResponse<VehicleOdometerAfterModificationPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/odometer-after-modification-photo`
  }).then(response => response.data)
}

export const deleteVehicleOdometerAfterModificationPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<VehicleOdometerAfterModificationPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/odometer-after-modification-photo`
    )
    .then(response => response.data)

export const getNeedsClusterReinstalledClusterWithOdometerLabelPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterReinstalledClusterWithOdometerPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/cluster-with-odometer-photo/`
    )
    .then(response => response.data)

export const updateNeedsClusterReinstalledClusterWithOdometerLabelPhotoInformation = (
  vehicleGuid: string,
  values: NeedsClusterReinstalledClusterWithOdometerPhotoDto
) => {
  const payload = new FormData()

  if (values.clusterReinstallClusterWithOdometerPhotoFile) {
    payload.append('clusterReinstallClusterWithOdometerPhotoFile', values.clusterReinstallClusterWithOdometerPhotoFile)
  }

  payload.append(
    'alsoUseForOdometerAfterModificationPhoto',
    String(values.alsoUseForOdometerAfterModificationPhoto ?? true)
  )

  if (values.clusterReinstallClusterWithOdometerIsTachometerPresent) {
    payload.append('clusterReinstallClusterWithOdometerIsTachometerPresent', values.clusterReinstallClusterWithOdometerIsTachometerPresent.toString())
  }

  if (values.clusterReinstallClusterWithOdometerIsOilPressureGaugePresent) {
    payload.append(
      'clusterReinstallClusterWithOdometerIsOilPressureGaugePresent',
      values.clusterReinstallClusterWithOdometerIsOilPressureGaugePresent.toString()
    )
  }

  if (values.clusterReinstallClusterWithOdometerIsTPMSPresent) {
    payload.append('clusterReinstallClusterWithOdometerIsTPMSPresent', values.clusterReinstallClusterWithOdometerIsTPMSPresent.toString())
  }

  return apiClient<ApiResponse<NeedsClusterReinstalledClusterWithOdometerPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/cluster-with-odometer-photo/`
  }).then(response => response.data)
}

export const deleteNeedsClusterReinstalledClusterWithOdometerLabelPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<NeedsClusterReinstalledClusterWithOdometerPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/cluster-with-odometer-photo/`
    )
    .then(response => response.data)
// #endregion

// #region Needs Cluster Reinstalled Importer Door Label
export const getNeedsClusterReinstalledImporterDoorLabelPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterReinstalledImporterDoorLabelPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/importer-door-label-photo/`
    )
    .then(response => response.data)

export const updateNeedsClusterReinstalledImporterDoorLabelPhotoInformation = (
  vehicleGuid: string,
  values: NeedsClusterReinstalledImporterDoorLabelPhotoDto
) => {
  const payload = new FormData()

  if (values.clusterReinstallImporterDoorLabelPhotoFile) {
    payload.append('clusterReinstallImporterDoorLabelPhotoFile', values.clusterReinstallImporterDoorLabelPhotoFile)
  }

  return apiClient<ApiResponse<NeedsClusterReinstalledImporterDoorLabelPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/importer-door-label-photo/`
  }).then(response => response.data)
}

export const deleteNeedsClusterReinstalledImporterDoorLabelPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<NeedsClusterReinstalledImporterDoorLabelPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/importer-door-label-photo/`
    )
    .then(response => response.data)
// #endregion

// #region Needs Cluster Reinstalled Combo Label
export const getNeedsClusterReinstalledComboLabelPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<NeedsClusterReinstalledComboPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/combo-photo/`)
    .then(response => response.data)

export const updateNeedsClusterReinstalledComboLabelPhotoInformation = (vehicleGuid: string, values: NeedsClusterReinstalledComboPhotoDto) => {
  const payload = new FormData()

  if (values.clusterReinstallComboPhotoFile) {
    payload.append('clusterReinstallComboPhotoFile', values.clusterReinstallComboPhotoFile)
  }

  return apiClient<ApiResponse<NeedsClusterReinstalledComboPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/combo-photo/`
  }).then(response => response.data)
}

export const deleteNeedsClusterReinstalledComboLabelPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<NeedsClusterReinstalledComboPhotoDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-cluster-reinstalled/combo-photo/`)
    .then(response => response.data)

// #region Michigan Titles
export const updateNeeds7501DocumentMichigan = (vehicleGuid: string, values: Needs7501DocumentMichiganEmailExporterDto) =>
  apiClient
    .post<ApiResponse<Needs7501DocumentMichiganEmailExporterDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-7501-document-michigan`, values)
    .then(response => response.data)

export const updateNeedsCANOwnershipMichigan = (vehicleGuid: string, values: NeedsCANOwnershipMichiganEmailExporterDto) =>
  apiClient
    .post<ApiResponse<NeedsCANOwnershipMichiganEmailExporterDto>>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-can-ownership-michigan`, values)
    .then(response => response.data)

// #endregion

// #region Needs To Be Moved To Staging
export const getNeedsToBeMovedToStagingDetails = (vehicleId: string) =>
  apiClient
    .get<ApiResponse<NeedsToBeMovedToStagingDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/needs-to-be-moved-to-staging`)
    .then(response => response.data)

export const updateNeedsToBeMovedToStagingDetails = (vehicleId: string, values: NeedsToBeMovedToStagingDetailsDto) =>
  apiClient
    .put<ApiResponse<NeedsToBeMovedToStagingDetailsDto>>(`/api/vehicles/${encodeURIComponent(vehicleId)}/needs-to-be-moved-to-staging`, values)
    .then(response => response.data)

export const getNeedsToBeMovedToStagingSearch = (search: string) =>
  apiClient
    .get<ApiResponse<NeedsToBeMovedToStagingDetailsDto | undefined>>('/api/vehicles/search-moved-to-staging?search=' + encodeURIComponent(search))
    .then(response => response.data)

export const getNeedsToBeMovedToStagingWarrantyCertPhotoInformation = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<NeedsToBeMovedToStagingWarrantyCertPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-to-be-moved-to-staging/warranty-cert-photo`
    )
    .then(response => response.data)

export const downloadWarrantyCertPhoto = (vehicleGuid: string, fileName: string) => {
  apiClient.get(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-to-be-moved-to-staging/${encodeURIComponent(fileName)}`).then(response => {
    const base64Data = response.data
    const buffer = base64ToArrayBuffer(base64Data)

    const extension = fileName.split('.').pop()?.toLowerCase()
    const mimeType = extension === 'png' ? 'image/png' : extension === 'jpg' || extension === 'jpeg' ? 'image/jpeg' : 'application/octet-stream'

    const blob = new Blob([buffer], { type: mimeType })
    const fileUrl = window.URL.createObjectURL(blob)

    window.open(fileUrl, '_blank')

    const a = document.createElement('a')
    a.href = fileUrl
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    setTimeout(() => URL.revokeObjectURL(fileUrl), 1000)
  })
}

export const updateNeedsToBeMovedToStagingWarrantyCertPhotoInformation = (vehicleGuid: string, values: NeedsToBeMovedToStagingWarrantyCertPhotoDto) => {
  const payload = new FormData()

  if (values.warrantyCertPhotoFile) {
    payload.append('warrantyCertPhotoFile', values.warrantyCertPhotoFile)
  }

  if (values.parkingSpace) {
    payload.append('parkingSpace', values.parkingSpace)
  }

  return apiClient<ApiResponse<NeedsToBeMovedToStagingWarrantyCertPhotoDto>>({
    data: payload,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-to-be-moved-to-staging/warranty-cert-photo`
  }).then(response => response.data)
}

export const deleteNeedsToBeMovedToStagingWarrantyCertPhoto = (vehicleGuid: string) =>
  apiClient
    .delete<ApiResponse<NeedsToBeMovedToStagingWarrantyCertPhotoDto>>(
      `/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-to-be-moved-to-staging/warranty-cert-photo`
    )
    .then(response => response.data)

export const prepVehicleForOutboundTrip = (vehicleGuid: string) =>
  apiClient.put<undefined>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/prep-vehicle-for-outbound-trip`).then(() => {})

export const getNeedsToBeMovedToStagingPhotoBase64 = (vehicleGuid: string, fileName: string) =>
  apiClient
    .get<string>(`/api/vehicles/${encodeURIComponent(vehicleGuid)}/needs-to-be-moved-to-staging/${encodeURIComponent(fileName)}`)
    .then(response => response.data)

// #endregion
// export const getOCRDocuments = (vehicleGuid: string, parameters: OCRDocumentsParameters) =>
//   apiClient
//     .get<ApiResponse<OCRDocumentDto[]>>(
//       `/api/vehicles/${encodeURIComponent(vehicleGuid)}/ocr-documents` + URIQuery({ ...parameters })
//     )
//     .then(response => response.data)

// export const createOCRDocument = (vehicleId: string, values: OCRDocumentDto) => {
//   const formData = new FormData()
//   formData.append('documentFile', values.documentFile!)

//   return apiClient
//     .post<ApiResponse<OCRDocumentDto>>(`/api/vehicles/${vehicleId}/ocr-documents`, formData)
//     .then(response => response.data)
// }

// export const getOCRDocumentFile = (vehicleId: string, fileName: string) =>
//   apiClient.get(`/api/vehicles/${vehicleId}/ocr-documents/${fileName}`).then(response => {
//     const buffer = base64ToArrayBuffer(response.data)
//     const file = new Blob([buffer])
//     const anchor = document.createElement('a')
//     anchor.href = window.URL.createObjectURL(file)
//     anchor.download = fileName
//     document.body.appendChild(anchor)
//     anchor.click()
//     document.body.removeChild(anchor)
//     // Uncomment below if you want to open file in new tab instead of download.
//     // Maxwell Sommer 09/27/2024
//     // const buffer = base64ToArrayBuffer(response.data)
//     // const file = new Blob([buffer], { type: 'image/png' })
//     // const fileUrl = window.URL.createObjectURL(file)
//     // const _newTab = window.open(fileUrl)
//   })

// export const deleteOCRDocuments = (vehicleId: string, dtos: OCRDocumentDto[]) =>
//   apiClient.delete(`/api/vehicles/${vehicleId}/ocr-documents`, { data: dtos }).then(response => response.data)
